<div role="document" class="modal-dialog">
  <div class="modal-content">
    <div class="modal-header">
      <h5 class="modal-title"> Configuration</h5>
      <p>Panneau : {{display.label}}</p>
    </div>
    <form [formGroup]="dataAbsenceForm" #f="ngForm" (ngSubmit)="isValid(f.form) && update()" >
    <div class="modal-body ">
        <div class="form-row">
          <div class="col-2">
              <label  for="Description" >Couleur</label>
          </div>
          <div class="col-6">
              <ng-select class="mb-2"
              dropdownPosition='bottom'
                [items]="DisplayColors" [multiple]="false"
                [bindLabel]="'label'"
                [closeOnSelect]="true" bindValue="name" formControlName="color"
                name="color">
              </ng-select>
          </div>
      </div>
      <div class="form-row">
          <div class="col-2">
              <label  for="Description" >Zones</label>
          </div>
          <div class="col-6">
              <ng-select class="mb-2" [items]="lstZones"
              [closeOnSelect]="false"
              bindValue="id" [(ngModel)]="selectedZones"
              name="selectedZones"
              dropdownPosition='bottom'
                [items]="DisplayModes" [multiple]="true"
                [bindLabel]="'label'"
                [closeOnSelect]="true" bindValue="name" formControlName="mode" >
              </ng-select>
          </div>
      </div>
    </div>
    <div class="modal-footer">
      <button type="button" class="btn btn-primary"  type="submit">Valider</button>
      <button type="button" class="btn btn-secondary" data-dismiss="modal" (click)="close()">Annuler
      </button>
    </div>
  </form>
  </div>

</div>
